import * as Yup from 'yup';

export const PartnerCardDetailsSchema = Yup.object().shape({
  owner: Yup.string(),
  ownerMail: Yup.string(),
  ownerCountry: Yup.string(),
  guestType: Yup.string(),
  nameOnCard: Yup.string(),
  surnameOnCard: Yup.string(),
  countryOnCard: Yup.string(),
  cityOnCard: Yup.string(),
  zipCodeOnCard: Yup.string(),
  addressOnCard: Yup.string(),
  phone: Yup.string(),
  email: Yup.string(),
  cardType: Yup.string(),
  cardStartDate: Yup.string(),
  cardExpDate: Yup.string(),
  issueNumber: Yup.string(),
  cvvNumber: Yup.string(),
  cardNumber: Yup.string(),
  isInvalid: Yup.boolean(),
});

export type TPartnerReservation = {
  partnerName: string;
  serviceName: string;
  arrivalDate: string;
  departureDate: string;
  partnerReservationNumber: string;
  partnerCalculationNumber: string;
  partnerCommision: number;
  partnerCommisionCurrency: string;
  numberOfBeds: number;
  numberOfGuests: number;
  totalPrice: number;
  totalPriceCurrency: string;
  currency: string;
  status: string;
  note: string;
  cancellationPolicy: null | string;
  payout: number;
  isGenius: boolean;
};

export type TPartnerReservationCardData = {
  owner: string;
  ownerMail: string;
  ownerCountry: string;
  guestType: string;
  nameOnCard: string;
  surnameOnCard: string;
  countryOnCard: string;
  cityOnCard: string;
  zipCodeOnCard: string;
  addressOnCard: string;
  phone: string;
  email: string;
  cardType: string;
  cardStartDate: null | string;
  cardExpDate: string;
  issueNumber: null | string;
  cvvNumber: string;
  cardNumber: string;
  isInvalid: boolean;
};
